import { render, staticRenderFns } from "./AdminCategoryEdit.vue?vue&type=template&id=6bbc41d5"
import script from "./AdminCategoryEdit.vue?vue&type=script&lang=js"
export * from "./AdminCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports